/**
 * Created by rathompson on 8/16/23
 * File: IpRestrictContext.tsx
 * Project: cloud-mgmt-modules ©
 * ©
 */

import { createContext, useState, useContext, VFC, Dispatch, SetStateAction, useCallback } from 'react'
import _ from 'lodash'
import { ERROR_API_IP_RESTRICTED } from '../constants/GlobalConstants'

const _setRestricted: Dispatch<SetStateAction<boolean>> = () => null
const _checkIpRestricted: (error: any) => boolean = () => false

const IpRestrictContext = createContext({
  isRestricted: false,
  setRestricted: _setRestricted,
  checkIpRestricted: _checkIpRestricted
})

/**
 * This will check if a error is caused by IP restriction
 * @param {any} error
 * @returns boolean
 */
export const ifIpRestricted = (error: any) => {
  let restricted = false
  if (
    (
      _.get(error, 'response.status') === 403 &&
      _.get(error, 'response.data._error.message') === ERROR_API_IP_RESTRICTED
    ) ||
    (
      _.get(error, '_error.code') === '403' &&
      _.get(error, '_error.message') === ERROR_API_IP_RESTRICTED
    )
  ) {
    restricted = true
  }
  return restricted
}

export const useIpRestrictionContext: () => {
  isRestricted: boolean,
  setRestricted: Dispatch<SetStateAction<boolean>>,
  checkIpRestricted: (error: any) => boolean
} = () => useContext(IpRestrictContext)

const IpRestrictProvider: VFC<any> = ({ children }) => {

  const [isRestricted, setRestricted] = useState(false)

  const checkIpRestricted = useCallback((error) => {
    const restricted = ifIpRestricted(error)
    if (restricted) {
      setRestricted(true)
    }
    return restricted
  }, [])

  return (
    <IpRestrictContext.Provider value={{ isRestricted, setRestricted, checkIpRestricted }}>
      {children}
    </IpRestrictContext.Provider>
  )
}

export default IpRestrictProvider
